"use client";
const e = Object.freeze({
  fast: 200,
  normal: 300,
  slow: 400
}), O = Object.keys(e);
export {
  e as MOTION_DURATIONS,
  O as MOTION_DURATION_KEYS
};
